import EmitionPoint from "./emitionPoint";

const EconActivity = class {
    constructor(object) {
        if (object === undefined || object === null) {
            this.id = null;
            this.emitionPoint = null;
            this.name = null;
            this.logoUrl = null;
            this.logoFile = null;
        } else {
            this.id = object.id || null;
            this.emitionPoint = new EmitionPoint(object.emitionPoint);
            this.name = object.name || null;
            this.logoUrl = object.logoUrl || null;
            this.logoFile = null;
        }
        
    }

    get logoName() {
        if (this.logoUrl !== undefined && this.logoUrl !== null) {
            let elements = this.logoUrl.split("/");
            return elements[elements.length - 1];
        } else { return "Seleccionar" }
    }
}

/**
 * `src` del logo de una actividad, o `null` si no tiene (H40). Antes se concatenaba
 * `$baseURL + logoUrl` sin revisar y sin logo quedaba un `<img>` roto con `src` «…/null».
 * Acepta el modelo o el objeto plano del store.
 */
export function activityLogoSrc(activity, baseURL = '') {
    const url = activity && activity.logoUrl;
    if (!url || url === 'null' || url === 'undefined') return null;
    if (/^(https?:|data:|blob:)/.test(url)) return url;
    return (baseURL || '') + url;
}

/** Iniciales para el marcador que reemplaza al logo: las de las dos primeras palabras. */
export function activityInitials(activity) {
    const words = String((activity && activity.name) || '').trim().split(/\s+/).filter(Boolean);
    const initials = words.slice(0, 2).map((w) => w.charAt(0).toUpperCase()).join('');
    return initials || '?';
}

export default EconActivity